import HealthRecordActions from './HealthRecordActions';

export default HealthRecordActions;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordActions/index.js